import { Link } from 'react-router-dom';
import { latestComics } from '@/mocks/comics';
import ComicCard from '@/components/base/ComicCard';

export default function LatestSection() {
  return (
    <section className="bg-background-50 py-14 md:py-20">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row gap-12 lg:gap-16">
          <div className="lg:w-[38%]">
            <span className="inline-block px-3 py-1 text-[11px] font-label font-medium text-foreground-500 border border-background-300/60 rounded-full whitespace-nowrap">
              最新上架
            </span>
            <h2 className="mt-5 text-2xl md:text-4xl font-heading font-black text-foreground-50 leading-tight">
              每日更新
              <br />
              <span className="text-accent-400">精彩不停</span>
              <span className="inline-block ml-2 text-2xl">📖</span>
            </h2>
            <p className="mt-8 text-sm text-foreground-500 leading-relaxed max-w-sm">
              韩漫网每日更新大量韩国漫画资源，确保你能第一时间阅读到最新章节。无论是热门连载还是经典完结，这里都能找到。
            </p>
            <Link
              to="/category/qihuan"
              className="inline-flex items-center gap-1 mt-6 text-sm text-primary-400 hover:text-primary-300 transition-colors whitespace-nowrap"
            >
              浏览最新漫画
              <i className="ri-arrow-right-line"></i>
            </Link>

            <div className="flex items-center gap-8 mt-10">
              {[
                { value: '120+', label: '每日更新' },
                { value: '50+', label: '新作上架' },
              ].map((item) => (
                <div key={item.label}>
                  <p className="text-3xl md:text-4xl font-heading font-black text-foreground-50">
                    {item.value}
                  </p>
                  <p className="text-xs text-foreground-500 mt-1">{item.label}</p>
                </div>
              ))}
            </div>
          </div>

          <div className="lg:w-[62%] grid grid-cols-2 md:grid-cols-3 gap-4">
            {latestComics.slice(0, 6).map((comic) => (
              <ComicCard key={comic.id} comic={comic} />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}